/**
 * @author Harshitha.k
 * @description 
 */

import axios from 'axios';
import dayjs from 'dayjs';
import moment from 'moment';
import InitialState from './const';
import { cloneDeep } from 'lodash';
import { connect } from 'react-redux';
import React, {Fragment, useEffect, useState ,useRef } from 'react';
import { localTimeConverter } from './utils';
import Highlighter from 'react-highlight-words';
import localStorage from '../../utils/localStorage';
import HierarchyModal from './utils/HierarchyModal';
import StyledTable from '../../commons/styles/table';
import { EditOutlined, PlusOutlined, SearchOutlined,ApartmentOutlined } from '@ant-design/icons';
import {
  Col,
  Row,
  Tabs,
  Button,
  Form,
  message,
  Input,
  Drawer,
  DatePicker,
  Select,
  Modal
} from 'antd';
import {
  getProcessArea,
  getAreaType,
  getDescription,
  saveDownTimelogs,
  getDownTimeRecords,
  editDownTimelogs,
  // getShift,
  submitDowntimeAPI,
  getShiftList,
  getDepartmentDetailsAPI,
  getEquipmentList,
  getTypeList,
  getFailureReasonList
} from './apiCalls';
import {
  WorkCenterSelect,
  FormLabel,
} from './styles';
import { StyledHomepage } from '../../commons/styles/layout';

const { Option } = WorkCenterSelect;
const { TextArea } = Input;
const { TabPane } = Tabs;

const DownTime = (props) => {
  const [state, setState] = useState(InitialState);
  const [searchText, setSearchText] = useState('');
  const searchInput = useRef(null);
  const [RemarksData, setRemarksData] = useState([]);
  const newLocal = true;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const processData = await getProcessArea();
        const areaTypeData = await getAreaType();
        const TypeList = await getTypeList();
        const downTimeRecords = await getDownTimeRecords('All');
        const autoDownTimeRecords = await getDownTimeRecords('Automation');
        const manualRecords = await getDownTimeRecords('Manual');
        const shiftList = await getShiftList();
        const deviceList = await getEquipmentList();
        const FailureReasonList = await getFailureReasonList();

        const HierarchyCode = JSON.parse(localStorage.get('modules')) || [];
          // props.userProfile?.belongsTo?.sites?.[localStorage.get('currentSite')]?.hierarchy?.[0]?.HierarchyCode;

        setState(prevState => ({
          ...prevState,
          processData: processData || [],
          areaType: areaTypeData,
          TypeList,
          deviceList,
          downTimeRecords: localTimeConverter(downTimeRecords),
          autoDownTimeRecords: localTimeConverter(autoDownTimeRecords),
          manualRecords: localTimeConverter(manualRecords),
          shiftList,
          HierarchyCode,
          visible: false,
          checkedValue: [],
          FailureReasonList,
          expandedKeys: []
        }));
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, [props.userProfile]);

  // const _getProcessOptionList = () => {
  //   const options = JSON.parse(localStorage.get('modules'));
  //   return options?.hierarchy || [];
  // };

  const disabledStartDate = (current) => {
    return current > dayjs().endOf('day');
  };

  const disabledEndDate = (current) => {
    const { totalFromDateTime } = state;
    return (
      current > dayjs(totalFromDateTime).add(1, 'day').endOf('day') ||
      current < dayjs(totalFromDateTime).startOf('day')
    );
  };

  const onChange = (field, value) => {
    setState(prevState => ({
      ...prevState,
      [field]: value
    }));
  };

  const onStartChange = (value) => {
    let { totalToDateTime } = state;
    onChange('totalFromDateTime', value);
    if (totalToDateTime !== null || totalToDateTime !== undefined || totalToDateTime !== '') {
      let valueString = moment(value).format('DD/MM/YYYY HH:mm');
      let toDateString = moment(totalToDateTime).format('DD/MM/YYYY HH:mm');

      if (toDateString !== 'Invalid Date' || toDateString === 'Invalid date' || toDateString > valueString) {
        let ms = moment(toDateString, 'DD/MM/YYYY HH:mm:ss').diff(moment(valueString, 'DD/MM/YYYY HH:mm:ss'));
        let d = moment.duration(ms);
        let s = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');

        if (toDateString !== 'Invalid date' || s !== 'NaNInvalid date') {
          setState(prevState => ({ ...prevState, totalTime: s, addArea: true }));
        }
      }
    }
  };

  const onEndChange = (value) => {
    const { totalFromDateTime } = state;
    let valueString = dayjs(value).format('DD/MM/YYYY HH:mm');
    let formDateString = dayjs(totalFromDateTime).format('DD/MM/YYYY HH:mm');

    if (valueString > formDateString) {
      let ms = moment(valueString, 'DD/MM/YYYY HH:mm:ss').diff(moment(formDateString, 'DD/MM/YYYY HH:mm:ss'));
      let d = moment.duration(ms);
      let s = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
      setState(prevState => ({ ...prevState, totalToDateTime: value, totalTime: s, addArea: true }));
    } else {
      message.warning('ToDateTime should be greater than FromDateTime');
    }
  };

  const handleStartOpenChange = (open) => {
    if (!open) {
      setState(prevState => ({ ...prevState, endOpen: true }));
    }
  };

  const handleEndOpenChange = (open) => {
    setState(prevState => ({ ...prevState, endOpen: open }));
  };

  const addSplitArea = () => {
    let splitData = [...state.splitDowntimeLog];
    let prevArea = splitData[splitData.length - 1];
    if (splitData.length > 0) {
      if (
        prevArea.FailureArea === '' ||
        prevArea.formDate === '' ||
        prevArea.toDate === '' ||
        prevArea.FailureReasons === ''
      ) {
        setState(prevState => ({ ...prevState, checkValidations: true }));
        return;
      } else {
        setState(prevState => ({ ...prevState, checkValidations: false }));
      }
    }

    let newObject = {
      FailureArea: '',
      StartTime: state.totalFromDateTime || null,
      EndTime: null,
      endOpen: false,
      FailureReasons: '',
      greyOut: false,
      TotalTime: '',
      Remarks: []
    };
    splitData.push(newObject);
    setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
  };

  const onSplitStartChange = (value, index) => {
    // Use the current state value for splitDowntimeLog and its setter
    setState(prevSplitData => {
      const splitData = [...prevSplitData];
      // Access other relevant state variables
      const totalFromDate = dayjs(totalFromDateTime).format('DD/MM/YYYY HH:mm');
      const totalToDate = dayjs(totalToDateTime).format('DD/MM/YYYY HH:mm');
      const valueString = dayjs(value).format('DD/MM/YYYY HH:mm');
  
      if (valueString >= totalFromDate && valueString <= totalToDate) {
        splitData[index]['StartTime'] = value;
        if (
          (splitData && splitData[index]['EndTime'] && splitData[index]['EndTime'] !== null) ||
          splitData[index]['EndTime'] !== undefined
        ) {
          const valueStringSec = moment(value).format('DD/MM/YYYY HH:mm:ss');
          const toDateString = moment(splitData[index]['EndTime']).format('DD/MM/YYYY HH:mm:ss');
          const ms = moment(toDateString, 'DD/MM/YYYY HH:mm:ss').diff(
            moment(valueStringSec, 'DD/MM/YYYY HH:mm:ss')
          );
          const d = moment.duration(ms);
          const time = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
          splitData[index]['TotalTime'] = time;
        }
        return splitData;
      } else {
        message.warn(`Please Select the range between ${totalFromDate} to ${totalToDate}`);
        return prevSplitData;
      }
    });
  };  

  const addAreaRemark = (i) => {
    const { userProfile } = props;
    const splitRecords = [...state.splitDowntimeLog];
    const username = userProfile?.user?.Id || '';

    if (splitRecords[i]?.Remarks) {
      splitRecords[i].Remarks.push({
        Remarks: '',
        Date: moment().format('YYYY-MM-DD HH:mm'),
        User: username,
      });
    } else {
      splitRecords[i].Remarks = [{
        Remarks: '',
        Date: moment().format('YYYY-MM-DD HH:mm'),
        User: username,
      }];
    }
    setState(prevState => ({ ...prevState, splitDowntimeLog: splitRecords }));
  };

  const onSplitEndChange = (value, index) => {
    const splitData = [...state.splitDowntimeLog];
    const { totalFromDateTime, totalToDateTime } = state;

    const totalFromDate = dayjs(totalFromDateTime).format('DD/MM/YYYY HH:mm');
    const totalToDate = dayjs(totalToDateTime).format('DD/MM/YYYY HH:mm');
    const valueString = dayjs(value).format('DD/MM/YYYY HH:mm');
    const formDateString = dayjs(splitData[index]['StartTime']).format('DD/MM/YYYY HH:mm');

    if (valueString > formDateString && valueString > totalFromDate && valueString <= totalToDate) {
      splitData[index]['EndTime'] = value;
      const ms = moment(valueString, 'DD/MM/YYYY HH:mm:ss').diff(moment(formDateString, 'DD/MM/YYYY HH:mm:ss'));
      const d = moment.duration(ms);
      const time = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
      splitData[index]['TotalTime'] = time;
      setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
    } else {
      splitData[index]['EndTime'] = null;
      setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
      message.warning('ToDateTime should be greater than FromDateTime');
    }
  };

  const handleSplitStartOpenChange = (status, index) => {
    const splitData = [...state.splitDowntimeLog];
    if (!status) {
      splitData[index]['endOpen'] = true;
      setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
    }
  };

  const handleSplitEndOpenChange = (open, index) => {
    const splitData = [...state.splitDowntimeLog];
    splitData[index]['endOpen'] = open;
    setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
  };

  const disabledSplitStartDate = (startValue, index) => {
    const { totalFromDateTime, totalToDateTime } = state;
    const startDate = moment(startValue).format('YYYY-MM-DD');
    const fromDate = moment(totalFromDateTime).format('YYYY-MM-DD');
    const toDate = moment(totalToDateTime).format('YYYY-MM-DD');

    if (newLocal) {
      return moment(startDate).isBefore(fromDate) || moment(startDate).isAfter(toDate);
    } else {
      const { splitDowntimeLog } = state;
      const validateDateTime = splitDowntimeLog[index - 1].toDate;
      const valDate = moment(validateDateTime).format('YYYY-MM-DD');
      return moment(startDate).isBefore(valDate) || moment(startDate).isAfter(toDate);
    }
  };

  const disabledSplitEndDate = (endValue, index) => {
    const { totalToDateTime } = state;
    const endDate = dayjs(endValue).format('YYYY-MM-DD');
    const toDate = dayjs(totalToDateTime).format('YYYY-MM-DD');

    const { splitDowntimeLog } = state;
    const validateDateTime = splitDowntimeLog[index].StartTime;
    const valDate = dayjs(validateDateTime).format('YYYY-MM-DD');
    return dayjs(endDate).isBefore(valDate) || dayjs(endDate).isAfter(toDate);
  };

  const openModel = () => {
    setRemarksData([]);
    setState(prevState => ({ ...prevState, openModel: !prevState.openModel }));
  };

  const handleModelSave = async () => {
    // Destructure all necessary state values
    const {
      editLog,
      editAutoLog,
      modifyRecord,
      EquipmentCode,
      TypeOfDowntime,
      splitDowntimeLog,
      DeletedFailureDetails,
      splitView,
      totalFromDateTime,
      totalToDateTime,
      Source,
      UpdateSource,
      totalTime,
      updateId,
      codeValue,
      // Remarks,
      SubEquipmentCode,
      Shift, // Include Shift as in the class component
    } = state;
  
    // Set splitStartRecord and splitEndRecord based on splitDowntimeLog
    splitDowntimeLog.forEach((area) => {
      const splitStart = moment(area.StartTime).format('YYYY-MM-DD HH:mm');
      const splitEnd = moment(area.EndTime).format('YYYY-MM-DD HH:mm');
      const startMainTime = moment(totalFromDateTime).format('YYYY-MM-DD HH:mm');
      const endMainTime = moment(totalToDateTime).format('YYYY-MM-DD HH:mm');
  
      if (splitStart === startMainTime) {
        setState(prev => ({ ...prev, splitStartRecord: true }));
      }
      if (splitEnd === endMainTime) {
        setState(prev => ({ ...prev, splitEndRecord: true }));
      }
    });
  
    // Validation for required fields in splitDowntimeLog
    let loopValidation = false;
    splitDowntimeLog && Array.isArray(splitDowntimeLog) && splitDowntimeLog.forEach((area) => {
      if (
        area.FailureArea === '' ||
        area.FailureReasons === '' ||
        area.StartTime === '' ||
        area.StartTime === null ||
        area.EndTime === '' ||
        area.TotalTime === ''
      ) {
        message.warn('Please select all fields');
        loopValidation = true;
        setState(prev => ({ ...prev, checkValidations: true }));
      }
    });
  
    // Convert StartTime and EndTime to UTC if present
    splitDowntimeLog && splitDowntimeLog.forEach((area) => {
      if (area.EndTime !== null) {
        area.EndTime = moment(area.EndTime).utc();
      } else if (area.EndTime === null || area.EndTime === '' || area.EndTime === undefined) {
        area.EndTime = null;
      }
      area.StartTime = moment(area.StartTime).utc();
    });
  
    if (loopValidation) {
      return;
    }
  
    // Edit mode: editLog, editAutoLog, or modifyRecord is true
    if (editLog || modifyRecord || editAutoLog) {
      if (
        EquipmentCode === '' ||
        totalTime === '' ||
        totalTime === null ||
        totalToDateTime === null
      ) {
        setState(prev => ({ ...prev, checkValidations: true, addArea: true }));
      } else {
        const obj = {
          EquipmentCode: codeValue,
          TypeOfDowntime,
          Source,
          UpdateSource,
          FailureDetails: [...splitDowntimeLog],
          splitView,
          StartTime: totalFromDateTime,
          EndTime: totalToDateTime,
          DeletedFailureDetails,
          TotalTime: totalTime,
          Id: updateId,
          Remarks:RemarksData,
          SubEquipmentCode,
          // Shift is not included in edit mode per class component
        };

        if (splitDowntimeLog.length !== 0) {
          await editDownTimelogs(obj);
          const downTimeRecords = await getDownTimeRecords('All');
          const autoDownTimeRecords = await getDownTimeRecords('Automation');
          const manualRecords = await getDownTimeRecords('Manual');
          const stateInit = cloneDeep(InitialState);
          stateInit.downTimeRecords = localTimeConverter(downTimeRecords);
          stateInit.autoDownTimeRecords = localTimeConverter(autoDownTimeRecords);
          stateInit.manualRecords = localTimeConverter(manualRecords);
          setState({ ...stateInit, Remarks: [] });
        } else {
          message.warn('Please add Atleast one area');
        }
      }
    } else {
      // Save new record mode
      let loopValidation = false;
      splitDowntimeLog.forEach((area) => {
        if (
          area.FailureArea === '' ||
          area.FailureReasons === '' ||
          area.StartTime === '' ||
          area.EndTime === '' ||
          area.TotalTime === ''
        ) {
          loopValidation = true;
          setState(prev => ({ ...prev, checkValidations: true }));
        }
      });
  
      if (loopValidation) {
        return;
      }
      if (
        EquipmentCode === '' ||
        TypeOfDowntime === '' ||
        TypeOfDowntime === null ||
        totalTime === '' ||
        totalTime === null ||
        totalFromDateTime === null ||
        totalToDateTime === null
      ) {
        setState(prev => ({ ...prev, checkValidations: true }));
        message.warn('Please Enter All Records With Atleast One Area');
      } else {
        const obj = {
          EquipmentCode: codeValue,
          TypeOfDowntime,
          FailureDetails: splitDowntimeLog,
          StartTime: totalFromDateTime,
          EndTime: totalToDateTime,
          TotalTime: totalTime,
          Status: 'Open',
          Source: 'Manual',
          Remarks:RemarksData,
          SubEquipmentCode,
          Shift,
          RecordStatus: 'Saved'
        };
  
        if (splitDowntimeLog.length !== 0) {
          try {
            const saveReponse = await saveDownTimelogs(obj);
            if (saveReponse) {
              const downTimeRecords = await getDownTimeRecords('All');
              const autoDownTimeRecords = await getDownTimeRecords('Automation');
              const manualRecords = await getDownTimeRecords('Manual');
              const stateInit = cloneDeep(InitialState);
              stateInit.downTimeRecords = localTimeConverter(downTimeRecords);
              stateInit.autoDownTimeRecords = localTimeConverter(autoDownTimeRecords);
              stateInit.manualRecords = localTimeConverter(manualRecords);
              setState({ ...stateInit, Remarks: [] });
            }
          } catch (error) {
            console.log(error);
            message.warn(`${error.response.message}`);
          }
        } else {
          message.warn('Please Add Atleast One Area');
        }
      }
    }
  };
  


  const handleOnChange = async (e, type) => {
    if (type === 'totalDownTimearea') {
      let descData = await getDescription(e);
      setState(prevState => ({
        ...prevState,
        [type]: e,
        totalDownDescriptionData: descData,
        totalDownDescription: ''
      }));
    } else if (type === 'shift') {
      const { shiftData } = state;
      let index = shiftData.findIndex((data) => data.ShiftName === e);
      setState(prevState => ({
        ...prevState,
        [type]: e,
        selectedShift: index !== -1 ? shiftData[index] : ''
      }));
    } else if (type === 'EquipmentCode') {
      let EquipmentPayload = {
        Type: 'FailureArea',
        Module: 'DownTime',
        EquipmentCode: e
      };
      let getDepartmentDetails = await getDepartmentDetailsAPI(EquipmentPayload);
      setState(prevState => ({
        ...prevState,
        [type]: e,
        EquipmentData: e,
        splitDowntimeLog: [],
        failureAreaList: getDepartmentDetails && Object.keys(getDepartmentDetails) ? Object.keys(getDepartmentDetails) : [],
        failureReasonList: getDepartmentDetails
      }));
    } else {
      setState(prevState => ({ ...prevState, [type]: e }));
    }
  };

  const handleSplitOnChange = async (val, type, index) => {
    const splitData = [...state.splitDowntimeLog];
    if (type === 'FailureArea') {
      splitData[index]['FailureArea'] = val;
      let descData = await getDescription(val);
      splitData[index]['descriptionData'] = descData;
      splitData[index]['FailureReasons'] = '';
      setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
    } else if (type === 'FailureReasons') {
      let findDuplicate = splitData.find((item) => {
        if (item.FailureReasons === val) {
          return true;
        } else {
          return false;
        }
      });
      if (!findDuplicate) {
        splitData[index]['FailureReasons'] = val;
        let descData = await getDescription(val);
       let valueDesc =  descData.filter((item)=>{
        return item.FailureCode === val;
      });
        splitData[index]['descriptionData'] = valueDesc;
        setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
      } else {
        message.warning('Duplicate Failure Descriptions not allowed');
        splitData[index]['FailureReasons'] = '';
        setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
      }
    } else {
      splitData[index][type] = val;
      setState(prevState => ({ ...prevState, splitDowntimeLog: splitData }));
    }
  };

  // const getDataForEdit = async () => {
  //   try {
  //     let processData = await getProcessArea();
  //     let areaTypeData = await getAreaType();
  //     let downTimeRecords = await getDownTimeRecords('All');
  //     let shiftData = await getShift();
  //     setState(prevState => ({
  //       ...prevState,
  //       processData,
  //       areaType: areaTypeData,
  //       downTimeRecords: localTimeConverter(downTimeRecords),
  //       shiftData
  //     }));
  //   } catch (error) {
  //     message.warn(`${error.message}`);
  //   }
  // };

  const handlelogEdit = async (logItem, type) => {
    const remarksData = logItem.Remarks || []; 
    if (type === 'auto') {
      setState(prevState => ({
        ...prevState,
        ProcessArea: logItem.ProcessArea,
        WorkCentre: logItem.WorkCentre,
        EquipmentName: logItem.EquipmentName,
        EquipmentCode: [logItem.EquipmentCode],
        TypeOfDowntime: logItem.TypeOfDowntime || '',
        shift: logItem.Shift,
        greyOutRecords: [],
        editAutoLog: true,
        openModel: true,
        totalTime: logItem.TotalTime,
        totalFromDateTime: logItem.StartTime ? moment(logItem.StartTime) : null,
        totalToDateTime: logItem.EndTime ? moment(logItem.EndTime) : null,
        Source: logItem.Source,
        UpdateSource: 'Manual',
        updateId: logItem.Id,
        splitView: logItem.FailureDetails.length > 0,
        Remarks: logItem.Remarks,
        RecordStatus: logItem.RecordStatus,
        workOrderId: logItem.WorkOrderId,
        notificationId: logItem.NotificationId,
        rootCause: logItem.Reason
      }));
      setRemarksData(remarksData);
    } else {
      let descData = type !== 'auto' ? await getDescription(logItem.FailureDetails[0]?.FailureArea) : [];
      setState(prevState => ({
        ...prevState,
        ProcessArea: logItem.ProcessArea,
        WorkCentre: logItem.WorkCentre,
        EquipmentCode: [logItem.EquipmentCode],
        EquipmentName: logItem.EquipmentName,
        TypeOfDowntime: logItem.TypeOfDowntime,
        Shift: logItem.Shift,
        splitDowntimeLog: logItem.FailureDetails,
        greyOutRecords: [],
        editLog: true,
        openModel: true,
        totalTime: logItem.TotalTime,
        Source: 'Manual',
        UpdateSource: 'Manual',
        totalFromDateTime: logItem.StartTime ? moment(logItem.StartTime) : null,
        totalToDateTime: logItem.EndTime ? moment(logItem.EndTime) : null,
        totalDownDescriptionData: descData,
        updateId: logItem.Id,
        splitView: logItem.FailureDetails.length > 0,
        Remarks: logItem.Remarks,
        RecordStatus: logItem.RecordStatus,
        workOrderId: logItem.WorkOrderId,
        notificationId: logItem.NotificationId,
        rootCause: logItem.Reason
      }));
      setRemarksData(remarksData);
    }
  };

  const handleCancel = async () => {
    let downTimeRecords = await getDownTimeRecords('All');
    let autoDownTimeRecords = await getDownTimeRecords('Automation');
    let manualRecords = await getDownTimeRecords('Manual');
    setState(prevState => {
      const updatedState = {
        ...prevState,
        downTimeRecords: localTimeConverter(downTimeRecords),
        autoDownTimeRecords: localTimeConverter(autoDownTimeRecords),
        manualRecords: localTimeConverter(manualRecords)
      };
      const stateInit = cloneDeep(InitialState);
      return { ...updatedState, ...stateInit, splitDowntimeLog: [], Remarks: [] };
    });
  };


  const addSplitAreaView = () => {
    let splitData = [...state.splitDowntimeLog];
    let newObject = {
      area: '',
      fromDate: '',
      toDate: '',
      endOpen: false,
      description: '',
      descriptionData: []
    };

    splitData.push(newObject);
    setState(prevState => ({
      ...prevState,
      splitView: true,
      splitDowntimeLog: splitData
    }));
  };

  const disabledStartTime = (val) => {
    const { shift, shiftData, selectedShift } = state;

    let index = shiftData && shiftData.findIndex(data => data.ShiftName === shift);
    if (selectedShift && selectedShift.FromTime && selectedShift.ToTime) {
      let startHours = selectedShift.FromTime.split(':')[0];
      let endHours = shiftData[index].ToTime.split(':')[0];
      let beforeHours = range(0, startHours);
      let afterHours = range(endHours, 24);
      let valHours = moment(val).hours();

      if (shift === 'Night') {
        afterHours = [];
        beforeHours.splice(beforeHours.indexOf(0), Number(endHours) + 1);
      }

      if (valHours === Number(endHours)) {
        return {
          disabledHours: () => [...beforeHours, ...afterHours],
          disabledMinutes: () => range(1, 59),
          disabledSeconds: () => range(1, 59)
        };
      }
      return {
        disabledHours: () => [...beforeHours, ...afterHours],
        disabledMinutes: () => range(0, 0)
      };
    } else {
      return true;
    }
  };

  const range = (start, end) => {
    return Array.from({ length: end - start }, (_, i) => start + i);
  };

  const disabledEndTime = (val) => {
    const { shift, selectedShift, totalFromDateTime } = state;

    if (selectedShift && selectedShift.FromTime && selectedShift.ToTime) {
      const hours = moment(totalFromDateTime).hours();
      const mins = moment(totalFromDateTime).minutes();
      const seconds = moment(totalFromDateTime).seconds();
      const fromDate = moment(totalFromDateTime).format('YYYY-MM-DD');
      const toDate = moment(val).format('YYYY-MM-DD');
      const valHours = moment(val).hours();
      const endHours = selectedShift.ToTime.split(':')[0];
      const startHours = selectedShift.FromTime.split(':')[0];
      const beforeHours = range(0, hours);
      const afterHours = range(endHours, 24);

      if (shift === 'Night') {
        if (moment(fromDate).isSame(toDate)) {
          if (hours >= startHours) {
            return {
              disabledHours: () => [...beforeHours],
              disabledMinutes: () => range(0, mins),
              disabledSeconds: () => range(0, seconds),
            };
          } else if (hours <= endHours) {
            if (valHours === Number(endHours)) {
              return {
                disabledHours: () => [...beforeHours, ...afterHours],
                disabledMinutes: () => range(selectedShift.ToTime.split(':')[1], 60),
                disabledSeconds: () => range(1, 60),
              };
            } else {
              return {
                disabledHours: () => [...beforeHours, ...afterHours],
                disabledMinutes: () => range(0, mins),
                disabledSeconds: () => range(0, seconds),
              };
            }
          }
        } else {
          if (valHours === Number(endHours)) {
            return {
              disabledHours: () => [...afterHours],
              disabledMinutes: () => range(selectedShift.ToTime.split(':')[1], 60),
              disabledSeconds: () => range(1, 60),
            };
          }
          return {
            disabledHours: () => [...afterHours],
            disabledMinutes: () => range(0, mins),
            disabledSeconds: () => range(0, seconds),
          };
        }
      }

      if (moment(fromDate).isSame(toDate)) {
        if (valHours === hours) {
          return {
            disabledHours: () => [...beforeHours, ...afterHours],
            disabledMinutes: () => range(0, mins),
            disabledSeconds: () => range(0, 0),
          };
        }

        if (valHours === Number(endHours)) {
          return {
            disabledHours: () => [...beforeHours, ...afterHours],
            disabledMinutes: () => range(1, 60),
            disabledSeconds: () => range(1, 60),
          };
        }
        return {
          disabledHours: () => [...beforeHours, ...afterHours],
          disabledMinutes: () => range(0, 0),
          disabledSeconds: () => range(0, seconds),
        };
      }
    } else {
      return true;
    }
  };

  // const disabledSplitStartTime = (val, i) => {
  //   const valHours = moment(val).hours();
  //   const valMinute = moment(val).minutes();
  //   const { totalFromDateTime, totalToDateTime } = state;

  //   if (newLocal) {
  //     const hours = moment(totalToDateTime).hours();
  //     const toHours = moment(totalFromDateTime).hours();
  //     const totalHours = range(0, 24).splice(hours + 1, 24);
  //     const fromStartHours = range(0, 24).splice(0, toHours);
  //     const mins = moment(totalFromDateTime).minutes();
  //     const seconds = moment(totalFromDateTime).seconds();

  //     if (valHours !== hours) {
  //       return {
  //         disabledHours: () => [...fromStartHours, ...totalHours],
  //         disabledMinutes: () => range(0, 0),
  //         disabledSeconds: () => range(0, 0),
  //       };
  //     }
  //     if (valMinute !== mins) {
  //       return {
  //         disabledHours: () => [...fromStartHours, ...totalHours],
  //         disabledMinutes: () => range(0, mins),
  //         disabledSeconds: () => range(0, 0),
  //       };
  //     }
  //     return {
  //       disabledHours: () => [...fromStartHours, ...totalHours],
  //       disabledMinutes: () => range(0, mins),
  //       disabledSeconds: () => range(0, seconds),
  //     };
  //   } else {
  //     const toDateTime = state.splitDowntimeLog[i - 1].toDate;
  //     const hours = moment(toDateTime).hours();
  //     const mins = moment(toDateTime).minutes();
  //     const seconds = moment(toDateTime).seconds();
  //     const toDate = moment(toDateTime).format('YYYY-MM-DD');
  //     const fromDate = moment(val).format('YYYY-MM-DD');

  //     if (moment(fromDate).isSame(toDate)) {
  //       if (valHours !== hours) {
  //         return {
  //           disabledHours: () => range(0, 24).splice(0, hours),
  //           disabledMinutes: () => range(0, 0),
  //           disabledSeconds: () => range(0, 0),
  //         };
  //       }
  //       if (valMinute !== mins) {
  //         return {
  //           disabledHours: () => range(0, 24).splice(0, hours),
  //           disabledMinutes: () => range(0, mins),
  //           disabledSeconds: () => range(0, 0),
  //         };
  //       }
  //       return {
  //         disabledHours: () => range(0, 24).splice(0, hours),
  //         disabledMinutes: () => range(0, mins),
  //         disabledSeconds: () => range(0, seconds),
  //       };
  //     }
  //   }
  // };

  // const disabledSplitEndTime = (val) => {
  //   const valHours = moment(val).hours();
  //   const valMinute = moment(val).minutes();

  //   if (newLocal) {
  //     const { totalFromDateTime, totalToDateTime } = state;
  //     const hours = moment(totalToDateTime).hours();
  //     const toHours = moment(totalFromDateTime).hours();
  //     const totalHours = range(0, 24).splice(hours + 1, 24);
  //     const fromStartHours = range(0, 24).splice(0, toHours);
  //     const mins = moment(totalFromDateTime).minutes();
  //     const seconds = moment(totalFromDateTime).seconds();

  //     if (valHours !== hours) {
  //       return {
  //         disabledHours: () => [...fromStartHours, ...totalHours],
  //       };
  //     }
  //     if (valMinute !== mins) {
  //       return {
  //         disabledHours: () => [...fromStartHours, ...totalHours],
  //         disabledMinutes: () => range(0, mins),
  //         disabledSeconds: () => range(0, 0),
  //       };
  //     }
  //     return {
  //       disabledHours: () => [...fromStartHours, ...totalHours],
  //       disabledMinutes: () => range(0, mins),
  //       disabledSeconds: () => range(0, seconds),
  //     };
  //   }
  // };

  // const handleAreaDelete = (index) => {
  //   const splitRecords = [...state.splitDowntimeLog];
  //   const DeletedFailureDetails = [];
  //   const deleteID = splitRecords.filter((_, indexEdit) => indexEdit === index);
  //   const data = deleteID[0].Id;
  //   DeletedFailureDetails.push(data);

  //   splitRecords.splice(index, 1);
  //   setState(prevState => ({ ...prevState, splitDowntimeLog: splitRecords, DeletedFailureDetails }));
  // };

  const getHierarchyLevels = (key) => {
    const { HierarchyCode } = state;
    const payload = {
      HierarchyCode: HierarchyCode.hierarchy[0].HierarchyCode,
      Type: 'Asset',
    };
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    const headers = {
      method: 'GET',
      url: `/api/hierarchymodule/getHierarchyLevels?HierarchyCode=${payload.HierarchyCode}&SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    axios(headers)
      .then(({ data }) => {
        if (Array.isArray(data)) {
          setState(prevState => ({
            ...prevState,
            treeData: data,
            [key]: true,
          }));
        }
      })
      .catch(() => { });
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, fontSize: '130%' }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  // const onExpand = (expandedKeys) => {
  //   setExpandedKeys(expandedKeys);
  // };

  const submitDowntime = async (Id) => {
    const SiteId = localStorage.get('currentSite');
    const payload = {
      DownTimeIds: [Id],
      RecordStatus: 'Submitted',
      SiteId
    };
    const submittedResponse = await submitDowntimeAPI(payload);
    if (submittedResponse && submittedResponse.message) {
      message.success(submittedResponse.message);
      const autoRecords = await getDownTimeRecords('Automation');
      const manualRecords = await getDownTimeRecords('Manual');
      setState(prevState => ({
        ...prevState,
        autoDownTimeRecords: localTimeConverter(autoRecords),
        manualRecords: localTimeConverter(manualRecords)
      }));
    }
  };

  const showRemarks = (logItem) => {
    let ChildRemarks = [];
   logItem.FailureDetails &&
      Array.isArray(logItem.FailureDetails) &&
      logItem.FailureDetails.map((failure) => {
        ChildRemarks = [
          ...ChildRemarks,
          ...(failure && failure.Remarks && Array.isArray(failure.Remarks) ? failure.Remarks : [])
        ];
        return {};
      });
    setState(prevState => ({
      ...prevState,
      Remarksvisible:true,
      manualRemarks:[...logItem.Remarks, ...ChildRemarks]
    }));
  };
  // const handleMainRemark = (e, i) => {
  //   const updatedRemarks = [...state.Remarks];
  //   updatedRemarks[i]['Remarks'] = e;
  //   setState(updatedRemarks);
  // };  
  const handleMainRemark = (e, i) => {
    setRemarksData(prevRemarks => {
      const newRemarks = [...prevRemarks];
      newRemarks[i] = { ...newRemarks[i], Remarks: e };
      return newRemarks;
    });
  };
  
    const handlechangeRemark = (e, k, index, i) => {
      const value = e.target ? e.target.value : e;
      setState(prevState => {
        const updatedLogs = [...prevState.splitDowntimeLog];
        updatedLogs[i]['Remarks'][index]['Remarks'] = value;
        return { ...prevState, splitDowntimeLog: updatedLogs };
      });
    };

  const add = () => {
    const userId = props.userProfile && props.userProfile.user ? props.userProfile.user.Id : '';

    if (RemarksData && Array.isArray(RemarksData)) {
      setRemarksData(prevRemarks => [
        ...prevRemarks,
        {
          Remarks: '',
          Date: moment().format('YYYY-MM-DD HH:mm'),
          User: userId
        }
      ]);
    } else {
      setRemarksData([
        {
          Remarks: '',
          Date: moment().format('YYYY-MM-DD HH:mm'),
          User: userId
        }
      ]);
    }
  };
    
  
  const onModalOk = () => {
    setState(prev=>({
      ...prev,
      visible:false,
      EquipmentCode:SelectedValue
    }));
  };

  const onModalCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      message.error('Please Select Device');
    } else {
      setState({visible:false});
    }
    setState({SelectedValue:[]});
  };

  const hierarchyDropdownChange = (value,data,code) => {
    setState({
      ...state,
      SelectedValue:value,
      key :data,
      codeValue : code
    });
  };

  const {
    splitDowntimeLog,
    areaType,
    downTimeRecords,
    autoDownTimeRecords,
    manualRecords,
    totalFromDateTime,
    totalToDateTime,
    totalTime,
    splitView,
    greyOutRecords,
    editLog,
    editAutoLog,
    modifyRecord,
    checkValidations,
    addArea,
    EquipmentCode,
    TypeOfDowntime,
    subEquipmentList,
    hasSubEquipment,
    SubEquipmentCode,
    Shift,
    manualRemarks,
    parentId,
    // Remarks,
    shiftList,
    TypeList,
    FailureReasonList,
    RecordStatus,
    deviceList,
    // visible,
    // Remarksvisible,
    // treeData,
    SelectedValue,
  } = state;

  const closedColumns = [
    {
      title: 'Id',
      dataIndex: 'Id',
      key: 'Id',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.Id - b.Id,
    },
    {
      title: 'Equipment',
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode'),
    },
    {
      title: 'Type',
      dataIndex: 'TypeOfDowntime',
      key: 'TypeOfDowntime',
    },
    {
      title: 'From Time',
      dataIndex: 'StartTime',
      key: 'StartTime',
      defaultSortOrder: 'descend',
    },
    {
      title: 'To Time',
      dataIndex: 'EndTime',
      key: 'EndTime',
    },
    {
      title: 'Total Time',
      dataIndex: 'TotalTime',
      key: 'totime',
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'Status',
      render: (text, record) => <span>{text === 'Open' ? 'Running' : record.Status}</span>,
    },
    {
      title: 'Edit',
      key: 'Edit',
      render: (text, record) => (
        <span>
          <EditOutlined onClick={() => handlelogEdit(record)} />
        </span>
      ),
    },
  ];

  const autoColumns = [
    {
      title: 'Id',
      dataIndex: 'Id',
      key: 'Id',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.Id - b.Id,
    },
    {
      title: 'Equipment',
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode'),
    },
    {
      title: 'Type',
      dataIndex: 'TypeOfDowntime',
      key: 'TypeOfDowntime',
    },
    {
      title: 'From',
      dataIndex: 'StartTime',
      key: 'StartTime',
    },
    {
      title: 'To',
      dataIndex: 'EndTime',
      key: 'EndTime',
    },
    {
      title: 'Total Time',
      dataIndex: 'TotalTime',
      key: 'totime',
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'Status',
      render: (text, record) => <span>{text === 'Open' ? 'Running' : record.Status}</span>,
    },
    {
      title: 'Edit',
      key: 'Edit',
      render: (text, record) => (
        <span>
          <EditOutlined onClick={() => handlelogEdit(record, 'auto')} />
        </span>
      ),
    },
    {
      title: 'Action',
      key: '',
      render: (text, record) => (
        <div>
          {record && record.RecordStatus && record.RecordStatus !== 'Saved' ? (
            <div style={{ color: '#006500' }}>Submitted</div>
          ) : (
            <Button
              style={{ background: '#1a3652' }}
              type="primary"
              onClick={() => submitDowntime(text.Id)}
            >
              Submit
            </Button>
          )}
        </div>
      ),
    },
  ];

  const Remarkscolumns = [
    {
      title: 'Date',
      dataIndex: 'Date',
      key: 'Date',
    },
    {
      title: 'User',
      dataIndex: 'User',
      key: 'User',
    },
    {
      title: 'Remarks ',
      dataIndex: 'Remarks',
      key: 'Remarks',
    },
  ];

  const manualColumns = [
    {
      title: 'Id',
      dataIndex: 'Id',
      key: 'Id',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.Id - b.Id,
    },
    {
      title: 'Equipment',
      dataIndex: 'DisplayCode',
      key: 'DisplayCode',
      ...getColumnSearchProps('DisplayCode'),
    },
    {
      title: 'Type',
      dataIndex: 'TypeOfDowntime',
      key: 'TypeOfDowntime',
    },
    {
      title: 'From',
      dataIndex: 'StartTime',
      key: 'StartTime',
    },
    {
      title: 'To',
      dataIndex: 'EndTime',
      key: 'EndTime',
    },
    {
      title: 'Total Time',
      dataIndex: 'TotalTime',
      key: 'totime',
    },
    {
      title: 'Status',
      dataIndex: 'Status',
      key: 'Status',
      render: (text, record) => <span>{text === 'Open' ? 'Running' : record.Status}</span>,
    },
    {
      title: 'Edit',
      key: 'Edit',
      render: (text, record) => (
        <span>
          <EditOutlined onClick={() => handlelogEdit(record)} />
        </span>
      ),
    },
    {
      title: 'Action',
      key: '',
      render: (text, record) => (
        <div>
          {record && record.RecordStatus && record.RecordStatus !== 'Saved' ? (
            <div style={{ color: '#006500' }}>Submitted</div>
          ) : (
            <Button
              style={{ background: '#1a3652' }}
              type="primary"
              onClick={() => submitDowntime(text.Id)}
            >
              Submit
            </Button>
          )}
        </div>
      ),
    },
    {
      title: ' ',
      key: '',
      render: (text, record) => (
        <div>
          <Button
            style={{ background: '#1a3652' }}
            type="primary"
            onClick={() => showRemarks(record)}
          >
            Show Remarks
          </Button>
        </div>
      ),
    },
  ];

  const expandedRowRender = (record) => {
    const columns = [
      { title: 'Area', dataIndex: 'FailureArea', key: 'FailureArea' },
      { title: 'Failure Reasons', dataIndex: 'FailureReasons', key: 'FailureReasons' },
      { title: 'Start Time', dataIndex: 'StartTime', key: 'StartTime' },
      { title: 'End Time', dataIndex: 'EndTime', key: 'EndTime' },
      { title: 'Total Time', dataIndex: 'TotalTime', key: 'TotalTime' },
    ];
    const data = record.FailureDetails.length === 0
      ? [{
        FailureArea: record.FailureArea,
        DescriptionText: record.DescriptionText,
        fromDate: record.StartTime,
        toDate: record.EndTime,
        totalTime: record.TotalTime,
      }]
      : record.FailureDetails;

    return (
      <StyledTable size="small"
        columns={columns}
        dataSource={data}
        pagination={false}
      />
    );
  };

  const tailFormItemLayout = {
    wrapperCol: {
      xs: { span: 24, offset: 0 },
      sm: { span: 16, offset: 8 },
    },
  };

  const dynamicAreas = (splitData, i, flage) => {
    const AddAreaFormItems =
      splitData &&
      splitData['Remarks'] &&
      Array.isArray(splitData['Remarks']) &&
      splitData['Remarks'].map((k, indexs) => (
        <Form.Item
          // label={'Remarks'}
          required={false}
          key={indexs}
        >
          <TextArea
            placeholder="Remarks"
            value={k.Remarks !== '' ? k.Remarks : null}
            allowClear
            style={{ width: '50%' }}
            onChange={(e) => {
              handlechangeRemark(e.target.value, k, indexs, i);
            }}
            rows={2}
          />
        </Form.Item>
      ));

    return (
      <Fragment>
        <div
          style={{
            opacity: RecordStatus === 'Submitted' ? 0.75 : 1,
            pointerEvents: RecordStatus === 'Submitted' ? 'none' : 'initial'
          }}
        >
          <Row
            gutter={24}
            style={{
              marginTop: '2%',
              marginBottom: '2%'
            }}
          >
            <Col span={6}>
              <Form.Item
                label={<FormLabel>Area</FormLabel>}
                hasFeedback={splitData.FailureArea !== '' ? true : false}
                validateStatus={
                  checkValidations
                    ? splitData.FailureArea !== ''
                      ? 'success'
                      : 'error'
                    : 'success'
                }
              >
                <Select
                  placeholder="Select Area"
                  // disabled={
                  //   editLog ? (splitData.greyOut ? true : false) : false
                  // }
                  style={{ width: 250 }}
                  value={splitData.FailureArea === '' ? undefined : splitData.FailureArea}
                  onChange={(e) => {
                    handleSplitOnChange(e, 'FailureArea', i);
                  }}
                >
                  {areaType &&
                    Array.isArray(areaType) &&
                    areaType.map((areaID, index) => {
                      return (
                        <Option
                          key={index}
                          value={areaID.DepartmentName}
                        // disabled={state.selectedAreas.includes(areaID)}
                        >
                          {areaID.DepartmentName}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={<FormLabel>Downtime Failure Reason</FormLabel>}
                hasFeedback={splitData.FailureReasons !== '' ? true : false}
                validateStatus={
                  checkValidations
                    ? splitData.FailureReasons !== ''
                      ? 'success'
                      : 'error'
                    : 'success'
                }
              >
                <Select
                  placeholder="Select Downtime Failure Reason"
                  value={splitData.FailureReasons === '' ? undefined : splitData.FailureReasons}
                  style={{ width: 550 }}
                  onChange={(e) => {
                    handleSplitOnChange(e, 'FailureReasons', i);
                  }}
                // disabled={
                //   editLog ? (splitData.greyOut ? true : false) : false
                // }
                >
                  {/* {splitData.descriptionData
                    ? splitData.descriptionData.map((area, index) => {
                      return (
                        <Option key={index} value={area.FailureReasons}>
                          {area.FailureReasons}
                        </Option>
                      );
                    })
                    : null} */}
                  {FailureReasonList &&
                    Array.isArray(FailureReasonList) &&
                    FailureReasonList.map((FailureReason, index) => {
                      return (
                        <Option
                          key={index}
                          value={FailureReason.FailureCode}
                        // disabled={state.selectedAreas.includes(areaID)}
                        >
                          {FailureReason.FailureCode}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label={<FormLabel>From DateTime</FormLabel>}
                hasFeedback={splitData.FromTime !== '' ? true : false}
                validateStatus={
                  checkValidations
                    ? splitData.FromTime !== null
                      ? 'success'
                      : 'error'
                    : 'success'
                }
              >
                <DatePicker
                  disabledDate={(val) => disabledSplitStartDate(val, i)}
                  // disabledTime={(val) => disabledsplitStartTime(val, i)}
                  //showTime={{ format: 'HH:mm' }}
                  format="YYYY-MM-DD HH:mm"
                  // value={totalFromDateTime}
                  value={splitData.StartTime !== null ? dayjs(splitData.StartTime) : null}
                  placeholder="Start DateTime"
                  onChange={(val) => onSplitStartChange(val, i)}
                  onOpenChange={(status) => handleSplitStartOpenChange(status, i)}
                  style={{ width: 250 }}
                  // disabled={
                  //   modifyRecord || editLog
                  //     ? splitData.greyOut
                  //       ? true
                  //       : true
                  //     : true
                  // }
                  showTime={{
                    defaultValue: dayjs('00:00', 'HH:mm')
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={<FormLabel>To DateTime</FormLabel>}
                hasFeedback={splitData.EndTime !== '' ? true : false}
                validateStatus={
                  checkValidations
                    ? splitData.EndTime !== null
                      ? 'success'
                      : 'error'
                    : 'success'
                }
              >
                <DatePicker
                  disabledDate={(val) => disabledSplitEndDate(val, i)}
                  showTime
                  format="YYYY-MM-DD HH:mm"
                  value={splitData.EndTime !== null ? dayjs(splitData.EndTime) : null}
                  style={{ width: 250 }}
                  placeholder="End DateTime"
                  onChange={(val) => onSplitEndChange(val, i)}
                  open={splitData.endOpen}
                  onOpenChange={(status) => handleSplitEndOpenChange(status, i)}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label={<FormLabel>Time</FormLabel>}
                hasFeedback={splitData.TotalTime !== '' ? true : false}
                validateStatus={
                  checkValidations
                    ? splitData.TotalTime !== ''
                      ? 'success'
                      : 'error'
                    : 'success'
                }
              >
                <Input
                  style={{ width: 250 }}
                  placeholder="Total Time"
                  value={splitData.TotalTime !== undefined ? splitData.TotalTime : undefined}
                  disabled
                />
              </Form.Item>
            </Col>
            <Col
              style={{
                display: modifyRecord ? 'none' : null
              }}
              span={6}
            >
              {(i === (greyOutRecords?.length || 0) - 1) ? (
                splitDowntimeLog.length === 0 ? (
                  <Form.Item {...tailFormItemLayout}>
                    <Button
                      type="danger"
                      // disabled={checkValidations===true?false:true}
                      style={{ fontWeight: 700 }}
                      onClick={() => addSplitArea()}
                    >
                      Add Area
                    </Button>
                  </Form.Item>
                ) : null
              ) : null}
              {flage === 'splitLog' ? (
                i === splitDowntimeLog.length - 1 ? (
                  <Form.Item {...tailFormItemLayout}>
                    <Button
                      type="danger"
                      //  disabled={checkValidations===true?false:true}
                      style={{ fontWeight: 700 }}
                      onClick={() => addSplitArea()}
                    >
                      Add Area
                    </Button>
                  </Form.Item>
                ) : null
              ) : null}
            </Col>
          </Row>
          <Row
            style={{
              borderBottom: i >= 0 ? '1px solid' : 'none'
            }}
            gutter={24}
          >
            <Col span={24}>
              <Form.Item>
                <Button
                  type="primary"
                  onClick={() => addAreaRemark(i, parentId)}
                  style={{ marginTop: '10px' }}
                >
                  <PlusOutlined /> Add Remarks
                </Button>
                <div style={{ marginTop: '10px' }}> {AddAreaFormItems}</div>
              </Form.Item>
            </Col>
          </Row>
        </div>
      </Fragment>
    );
  };

  return (
    <StyledHomepage>
      <Tabs type="card" >
        <TabPane tab="Closed Records" key="1">
          <StyledTable size="small"
            style={{ marginTop: "20px" }}
            columns={closedColumns}
            expandedRowRender={expandedRowRender}
            dataSource={downTimeRecords}
          />
        </TabPane>
        <TabPane tab="Manual Records" key="2">
          <div style={{
            display: 'flex',
            flexDirection: "row-reverse",
            margin: '16px 0px'
          }}>
            <Button
              onClick={() => {
                openModel();
              }}
              type="primary"
            >
              Add DownTime
            </Button>
          </div>
          <StyledTable size="small"
            style={{ marginTop: "20px" }}
            columns={manualColumns}
            dataSource={manualRecords}
          />
        </TabPane>
        <TabPane tab="Automated Records" key="3">
          <StyledTable size="small"
            style={{ marginTop: "20px" }}
            columns={autoColumns}
            dataSource={autoDownTimeRecords}
          />
        </TabPane>
      </Tabs>

      <Drawer
        width={1200}
        title={<div>Add Downtime</div>}
        className="downtimedrawer"
        placement="right"
        closable
        open={state.openModel}
        footer={[
          <Button key="back" type='primary' style={{ marginLeft: '8px' }} onClick={handleCancel}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            style={{ fontWeight: 800, marginLeft: '8px' }}
            onClick={() => {
              handleModelSave();
            }}
            disabled={RecordStatus && RecordStatus === 'Submitted' ? true : false}
          >
            {editLog || editAutoLog ? (modifyRecord ? 'Modify' : 'Update') : 'Save'}
          </Button>
        ]}
        onClose={() => handleCancel()}
      >
        <Form layout="vertical">
          <div
            style={{
              opacity: RecordStatus === 'Submitted' ? 0.75 : 1,
              pointerEvents: RecordStatus === 'Submitted' ? 'none' : 'initial'
            }}
          >
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            >
              {editLog || editAutoLog ? null : (
                <Col className="gutter-row" span={6}>
                  <Form.Item
                    label={<FormLabel>Equipment</FormLabel>}
                    hasFeedback={EquipmentCode !== '' ? true : false}
                    validateStatus={
                      checkValidations ? (EquipmentCode !== '' ? 'success' : 'error') : 'success'
                    }
                  >
                    <Select
                      style={{ width: '100%' }}
                      value={EquipmentCode === '' ? undefined : EquipmentCode}
                      // placeholder={translation(props.translationCache, constant.SelectLocation)}
                      disabled={true}
                      suffixIcon={
                        <ApartmentOutlined
                          onClick={(e) => {
                            e.preventDefault();
                            getHierarchyLevels('visible');
                          }}
                        />
                      }
                    />
                    {deviceList &&
                      Array.isArray(deviceList) &&
                      deviceList.map((device, index) => {
                        return (
                          <Option key={index} value={device.DeviceCode}>
                            {' '}
                            {device.DeviceCode}{' '}
                          </Option>
                        );
                      })}
                  </Form.Item>
                </Col>
              )}

              {editAutoLog || editLog ? (
                <Col
                  className="gutter-row"
                  span={6}
                // span={6}
                >
                  <Form.Item
                    label={<FormLabel>Equipment</FormLabel>}
                    hasFeedback={EquipmentCode !== '' ? true : false}
                    validateStatus={
                      checkValidations ? (EquipmentCode !== '' ? 'success' : 'error') : 'success'
                    }
                  >
                    <WorkCenterSelect
                      placeholder="Select Equipment"
                      value={EquipmentCode === '' ? undefined : EquipmentCode}
                      disabled={editLog ? true : editAutoLog ? true : false}
                    ></WorkCenterSelect>
                  </Form.Item>
                </Col>
              ) : null}

              <Col
                className="gutter-row"
                span={6}
              // span={6}
              >
                {hasSubEquipment ? (
                  <Form.Item
                    label={<FormLabel>Sub Equipment</FormLabel>}
                    hasFeedback={SubEquipmentCode !== '' ? true : false}
                    validateStatus={
                      checkValidations ? (EquipmentCode !== '' ? 'success' : 'error') : 'success'
                    }
                  >
                    <WorkCenterSelect
                      placeholder="Select Sub Equipment"
                      value={SubEquipmentCode === '' ? undefined : SubEquipmentCode}
                      disabled={editLog}
                      onChange={(e) => {
                        handleOnChange(e, 'SubEquipmentCode');
                      }}
                    >
                      {subEquipmentList.map((list, index) => {
                        return (
                          <Option key={index} value={list.Id}>
                            {list.SubEquipmentName}
                          </Option>
                        );
                      })}
                    </WorkCenterSelect>
                  </Form.Item>
                ) : (
                  <Form.Item
                    label={<FormLabel>Type</FormLabel>}
                    hasFeedback={
                      TypeOfDowntime !== '' ? true : TypeOfDowntime !== '' ? true : false
                    }
                    validateStatus={
                      checkValidations ? (TypeOfDowntime !== '' ? 'success' : 'error') : 'success'
                    }
                  >
                    <WorkCenterSelect
                      placeholder="Type of DownTime"
                      value={TypeOfDowntime === '' ? undefined : TypeOfDowntime}
                      disabled={editLog}
                      onChange={(e) => {
                        handleOnChange(e, 'TypeOfDowntime');
                      }}
                    >
                      {/* <Option value="Planned">Planned</Option>
                    <Option value="UnPlanned">UnPlanned</Option> */}

                      {TypeList &&
                        Array.isArray(TypeList) &&
                        TypeList.map((list, index) => {
                          return (
                            <Option key={index} value={list.Type}>
                              {list.Type}
                            </Option>
                          );
                        })}
                    </WorkCenterSelect>
                  </Form.Item>
                )}
              </Col>
            </Row>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            // gutter={24}
            >
              <Col
                className="gutter-row"
                span={6}
              // span={6}
              >
                <Form.Item
                  label={<FormLabel>Shift</FormLabel>}
                  hasFeedback={Shift !== '' ? true : false}
                  validateStatus={
                    checkValidations ? (Shift !== '' ? 'success' : 'error') : 'success'
                  }
                >
                  <WorkCenterSelect
                    placeholder="Select Shift"
                    value={Shift === '' ? undefined : Shift}
                    disabled={editLog ? true : editAutoLog ? true : false}
                    onChange={(e) => {
                      handleOnChange(e, 'Shift');
                    }}
                  >
                    {shiftList &&
                      Array.isArray(shiftList) &&
                      shiftList.map((shifts, index) => {
                        return (
                          <Option key={index} value={shifts.Shift}>
                            {shifts.Shift}
                          </Option>
                        );
                      })}
                  </WorkCenterSelect>
                </Form.Item>
              </Col>
              <Col
                className="gutter-row"
                span={6}
              // span={6}
              >
                <Form.Item
                  label={<FormLabel>From DateTime</FormLabel>}
                  hasFeedback={totalFromDateTime !== '' ? true : false}
                  validateStatus={
                    checkValidations
                      ? totalFromDateTime !== '' || totalFromDateTime !== null
                        ? 'success'
                        : 'error'
                      : 'success'
                  }
                >
                  <DatePicker
                    disabledDate={(val) => disabledStartDate(val)}
                    disabledTime={(val) => disabledStartTime(val)}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    value={totalFromDateTime !== null ? totalFromDateTime : null}
                    placeholder="Start DateTime"
                    onChange={(val) => onStartChange(val)}
                    onOpenChange={(status) => handleStartOpenChange(status)}
                    style={{ width: 250 }}
                    disabled={modifyRecord || splitView}
                  // showTime={{
                  //   defaultValue: moment(selectedShift.FromTime, "HH:mm"),
                  // }}
                  />
                </Form.Item>
              </Col>
              <Col
                className="gutter-row"
                span={6}
              // span={6}
              >
                <Form.Item
                  label={<FormLabel>To DateTime</FormLabel>}
                  hasFeedback={totalToDateTime !== '' ? true : false}
                  validateStatus={
                    checkValidations ? (totalToDateTime !== '' ? 'success' : 'error') : 'success'
                  }
                >
                  <DatePicker
                    disabledDate={(val) => disabledEndDate(val)}
                    disabledTime={(val) => disabledEndTime(val)}
                    showTime={{ format: 'HH:mm' }}
                    format="YYYY-MM-DD HH:mm"
                    value={totalToDateTime !== null ? totalToDateTime : null}
                    placeholder="End DateTime"
                    style={{ width: 250 }}
                    onChange={(val) => onEndChange(val)}
                    onOpenChange={(status) => handleEndOpenChange(status)}
                    disabled={modifyRecord || splitView}
                  // showTime={{
                  //   defaultValue: moment(selectedShift.FromTime, "HH:mm"),
                  // }}
                  // onOk={(val)=>timeValidation(val)}
                  />
                </Form.Item>
              </Col>
              {!hasSubEquipment ? null : (
                <Col
                  className="gutter-row"
                  span={6}
                // span={6}
                >
                  <Form.Item
                    label={<FormLabel>Type</FormLabel>}
                    hasFeedback={TypeOfDowntime !== '' ? true : false}
                    validateStatus={
                      checkValidations ? (TypeOfDowntime !== '' ? 'success' : 'error') : 'success'
                    }
                  >
                    <WorkCenterSelect
                      placeholder="Type of DownTime"
                      value={TypeOfDowntime === '' ? undefined : TypeOfDowntime}
                      disabled
                      onChange={(e) => {
                        handleOnChange(e, 'TypeOfDowntime');
                      }}
                    >
                      {TypeList &&
                        Array.isArray(TypeList) &&
                        TypeList.map((list, index) => {
                          return (
                            <Option key={index} value={list.Type}>
                              {list.Type}
                            </Option>
                          );
                        })}
                    </WorkCenterSelect>
                  </Form.Item>
                </Col>
              )}

              <Col
                className="gutter-row"
                span={6}
              // span={6}
              >
                <Form.Item
                  label={<FormLabel>Total Time</FormLabel>}
                  // hasFeedback={totalTime !== "" ? false : false}
                  // validateStatus="success"
                  hasFeedback={totalTime !== '' || totalTime !== null ? true : false}
                  validateStatus={
                    checkValidations ? (totalTime !== '' ? 'success' : 'error') : 'success'
                  }
                >
                  <Input
                    placeholder="Total Times"
                    value={totalTime !== null ? totalTime : null}
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
            // gutter={24}
            >
              <Col
                style={{
                  display: splitView || modifyRecord || !editLog ? 'none' : null
                }}
                className="gutter-row"
                span={6}
              // span={6}
              >
                <Button
                  type="danger"
                  style={{ fontWeight: 700, marginTop: '18%' }}
                  onClick={() => addSplitAreaView()}
                >
                  Split DownTime
                </Button>
              </Col>
              {splitDowntimeLog && splitDowntimeLog.length > 0 || greyOutRecords && greyOutRecords.length > 0 ? null : (
                <Col
                  style={
                    {
                      // display: splitView ? null : "none",
                    }
                  }
                  className="gutter-row"
                  span={6}
                // span={6}
                >
                  <Button
                    type="danger"
                    disabled={addArea ? false : editAutoLog ? false : true}
                    style={{ fontWeight: 700, marginTop: '11%' }}
                    onClick={() => addSplitArea()}
                  >
                    Add Area
                  </Button>
                </Col>
              )}
            </Row>
            <Row
              style={{
                borderBottom: splitDowntimeLog && splitDowntimeLog.length > 0 ? '1px solid' : null
              }}
              gutter={24}
            >
              <Col span={24}>
                <Button type="primary" onClick={add} style={{ marginTop: '10px' }}>
                  <PlusOutlined /> Add Remarks
                </Button>
                <div style={{ marginTop: '10px' }}>
                    {RemarksData &&
                      Array.isArray(RemarksData) &&
                      RemarksData.map((k, index) => (
                        <Form.Item required={false} key={k.index}>
                          <TextArea
                            // value={ k.Remarks }
                            value={k.Remarks !== '' ? k.Remarks : null}
                            // disabled={editLog ? true : editAutoLog ? true : false}
                            placeholder={'Remarks'}
                            style={{ width: '50%' }}
                            onChange={(e) => {
                              // this.handleOnChange(e.target.value, "Remarks");
                              handleMainRemark(e.target.value, index);
                            }}
                            rows={2}
                          />
                        </Form.Item>
                      ))}
                  </div>
              </Col>
            </Row>
          </div>
        </Form>

        {greyOutRecords &&
          Array.isArray(greyOutRecords) &&
          greyOutRecords.map((data, index) => dynamicAreas(data, index, 'greyOut'))}
        {splitDowntimeLog &&
          Array.isArray(splitDowntimeLog) &&
          splitDowntimeLog.map((data, index) => dynamicAreas(data, index, 'splitLog'))}
      </Drawer>

      <Modal
        open={state.visible}
        width={800}
        closable
        // title={translation(translationCache, constant.hierarchy)}
        onOk={onModalOk}
        onCancel={onModalCancel}
      >
        {' '}
        <HierarchyModal
          value={state.deviceId}
          treeData={state.treeData}
          translationCache={props.translationCache}
          Key="Asset"
          handleDropdownChange={hierarchyDropdownChange}
          // handleParentNode={parentNode}
          deviceList={state.deviceList}
          selectedKeys={state.SelectedValue}
        />
      </Modal>
      <Drawer
        width={700}
        title="Remarks"
        closable
        open={state.Remarksvisible}
        onOk={() => {
          setState({ ...state,
            Remarksvisible: false });
        }}
        onCancel={() => {
          setState({ ...state,Remarksvisible: false });
        }}
        onClose={() => setState({...state, Remarksvisible: false })}
      >
        <StyledTable size="small" columns={Remarkscolumns}
          dataSource={manualRemarks} />

      </Drawer>
    </StyledHomepage>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.getUserProfile,
});

export default connect(mapStateToProps)(DownTime);